var exports = {
  "Q": "Result__Of4h7n",
};

module.exports = exports;
